export default "__VITE_ASSET__B0iFQsa3__"